"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Drawer = exports.COLLAPSIBLE_DRAWER_HEADER_HEIGHT = exports.PAGE_HEADER_HEIGHT = void 0;
const react_1 = require("@chakra-ui/react");
const react_2 = __importStar(require("react"));
const bs_1 = require("react-icons/bs");
const hooks_1 = require("../hooks");
const utils_1 = require("../utils");
const DelayedRender_1 = require("./utils/DelayedRender");
exports.PAGE_HEADER_HEIGHT = 73;
exports.COLLAPSIBLE_DRAWER_HEADER_HEIGHT = 44;
function computeDefaultInitialDrawerSize() {
    const pageHeight = document.body.offsetHeight;
    const pagePaneHeight = pageHeight - exports.PAGE_HEADER_HEIGHT;
    const totalDrawerHeight = Math.floor(pagePaneHeight * 0.4);
    return totalDrawerHeight - exports.COLLAPSIBLE_DRAWER_HEADER_HEIGHT;
}
function clampPanelSize(size, minSize, maxSize) {
    if (size < minSize)
        return minSize;
    if (maxSize && size > maxSize)
        return maxSize;
    return size;
}
const Drawer = ({ header, isOpen = null, onToggle, initialSize, children, animationSpeed = 200, delayRender, onResize, containerProps = {}, isCollapsible = true, fullscreenOnMobile = false, configKey = 'Base', showHeader = true, minSize = 150, maxSize, isResizeable = true, }) => {
    const { primaryColor } = (0, hooks_1.usePrimaryColor)();
    const { isOpen: internalIsOpen, onToggle: internalOnToggle } = (0, react_1.useDisclosure)();
    const headerRef = (0, react_2.useRef)(null);
    const [customDrawerSize, setCustomDrawerSize] = (0, hooks_1.usePersistedState)(null, `Drawer-${configKey}`);
    const drawerSize = (0, react_2.useMemo)(() => {
        var _a;
        return clampPanelSize((_a = customDrawerSize !== null && customDrawerSize !== void 0 ? customDrawerSize : initialSize) !== null && _a !== void 0 ? _a : computeDefaultInitialDrawerSize(), minSize, maxSize);
    }, [customDrawerSize, initialSize, maxSize, minSize]);
    const [isResizing, setIsResizing] = (0, react_2.useState)(false);
    const handleMouseMovement = (0, react_2.useCallback)((event) => {
        var _a, _b;
        if (isResizing) {
            const pageSize = document.body.offsetHeight;
            const headerHeight = (_b = (_a = headerRef.current) === null || _a === void 0 ? void 0 : _a.clientHeight) !== null && _b !== void 0 ? _b : 0;
            const size = pageSize - event.clientY - headerHeight;
            const computedMaxSize = pageSize - exports.PAGE_HEADER_HEIGHT;
            const constrainedSize = size < minSize ? minSize : size > computedMaxSize ? computedMaxSize : size;
            setCustomDrawerSize(constrainedSize);
            onResize && onResize();
        }
    }, [isResizing, minSize, onResize, setCustomDrawerSize]);
    const handleToggle = (0, react_2.useCallback)((event) => {
        event.stopPropagation();
        (onToggle || internalOnToggle)();
    }, [internalOnToggle, onToggle]);
    const handleStopResizing = (0, react_2.useCallback)(() => {
        setIsResizing(false);
    }, []);
    const handleStartResizing = (0, react_2.useCallback)((event) => {
        event.preventDefault();
        setIsResizing(true);
    }, []);
    (0, react_2.useEffect)(() => {
        document.addEventListener('mousemove', handleMouseMovement);
        document.addEventListener('mouseup', handleStopResizing);
        return () => {
            document.removeEventListener('mousemove', handleMouseMovement);
            document.removeEventListener('mouseup', handleStopResizing);
        };
    });
    const { breakpoints } = (0, react_1.useTheme)();
    const largeBreakpoint = (0, utils_1.isBreakpointObject)(breakpoints)
        ? breakpoints.lg
        : breakpoints[2];
    const isDesktop = (0, react_1.useMediaQuery)(`(min-width: ${largeBreakpoint})`)[0];
    const forceOpen = fullscreenOnMobile && !isDesktop;
    const headerComponent = typeof header !== 'string' ? (header) : (react_2.default.createElement(react_1.Text, { width: "full", padding: 5, flexGrow: 1 }, header));
    const combinedIsOpen = forceOpen ? true : isOpen === null ? internalIsOpen : isOpen;
    return (react_2.default.createElement(react_1.Flex, Object.assign({ position: "relative", flexDirection: "column", flexGrow: fullscreenOnMobile ? { base: 1, lg: 0 } : 0, backgroundColor: "black", borderTop: "1px solid", borderTopColor: "border", borderLeftColor: "border" }, containerProps),
        react_2.default.createElement(react_1.Box, { position: "absolute", zIndex: 400, height: "4px", left: 0, right: 0, onMouseDown: combinedIsOpen ? handleStartResizing : undefined, _hover: { backgroundColor: combinedIsOpen ? 'border' : undefined }, cursor: combinedIsOpen ? 'ns-resize' : undefined, hidden: !isResizeable }),
        react_2.default.createElement(react_1.Box, { ref: headerRef, borderBottom: "1px solid", borderBottomColor: combinedIsOpen ? primaryColor : 'transparent', hidden: (!showHeader || !headerComponent) && !combinedIsOpen }, showHeader && headerComponent && (react_2.default.createElement(react_1.Flex, { alignItems: "center", paddingY: "6px", alignContent: "top" },
            headerComponent,
            react_2.default.createElement(react_1.Box, { display: fullscreenOnMobile ? { base: 'none', lg: 'block' } : 'block', position: "relative", right: 2, padding: 1, borderRadius: "lg", fontSize: "1.25rem", cursor: "pointer", onClick: handleToggle, _hover: {
                    backgroundColor: 'buttonHover',
                } }, isCollapsible ? (combinedIsOpen ? (react_2.default.createElement(bs_1.BsArrowBarDown, null)) : (react_2.default.createElement(bs_1.BsArrowBarUp, null))) : null)))),
        react_2.default.createElement(react_1.Flex, { direction: "column", flexGrow: 1, transition: isResizing ? undefined : `height ${animationSpeed / 1000}s ease`, height: combinedIsOpen ? `${drawerSize}px` : 0, overflowY: "hidden", overflowX: "hidden", position: "relative" }, combinedIsOpen && (react_2.default.createElement(DelayedRender_1.DelayedRender, { delay: delayRender ? animationSpeed : 0 }, () => react_2.default.createElement(react_2.default.Fragment, null, children))))));
};
exports.Drawer = Drawer;
//# sourceMappingURL=Drawer.js.map